export default [
  {
    path: '/bons-echanges',
    name: 'bon-echange-list',
    props: true,
    component: () => import('@/views/exchangeVouchers/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: "Liste des bons d'échange",
      breadcrumb: [
        {
          text: "Bons d'échange",
          to: { name: 'bon-echange-list' },
        },
        {
          text: "Liste des bons d'échange",
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'supplier'],
    },
  },
  {
    path: '/bons-echanges/create',
    name: 'bon-echange-add',
    props: true,
    component: () => import('@/views/exchangeVouchers/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: "Ajouter un bon d'échange",
      breadcrumb: [
        {
          text: "Bons d'échange",
          to: { name: 'bon-echange-list' },
        },
        {
          text: "Ajouter un bon d'échange",
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/bons-echanges/show/:id',
    name: 'bon-echange-show',
    props: true,
    component: () => import('@/views/exchangeVouchers/Show.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: "Détails du bon d'échange",
      breadcrumb: [
        {
          text: "Bons d'échange",
          to: { name: 'bon-echange-list' },
        },
        {
          text: "Détails du bon d'échange",
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'supplier'],
    },
  },
  {
    path: '/bons-echanges/print/:id',
    name: 'bon-echange-print',
    props: true,
    component: () => import('@/views/exchangeVouchers/Show.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: "Impression du bon d'échange",
      breadcrumb: [
        {
          text: "Bons d'échange",
          to: { name: 'bon-echange-list' },
        },
        {
          text: 'Impression',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'supplier'],
    },
  },
  {
    path: '/bons-echanges/bulk-show',
    name: 'bon-echange-bulk-show',
    props: true,
    component: () => import('@/views/exchangeVouchers/BulkShow.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: "Impression groupée des bons d'échange",
      breadcrumb: [
        {
          text: "Bons d'échange",
          to: { name: 'bon-echange-list' },
        },
        {
          text: 'Impression groupée',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
]
